import style from './App.module.css'
import { Input } from './components/Input/Input';
import { Button } from './components/Button/Button';
import { useState } from 'react';
import { login } from './api/apiLogin';
import { Logo } from './components/Logo/Logo';


function App() {
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [textError, setTextError] = useState('')
  const [textSuccess, setTextSuccess] = useState('')

  function auth() {
    if (!username || !password) {
      return
    }

    setTextError('')
    setTextSuccess('')

    setLoading(true)
    login(username, password).then(response => {      
      setLoading(false)
      const {message, status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = "/add_policy/"
      } else {
        setTextError('Неверный логин или пароль.')
      }
    })
  }

  return (
    <div className={style.back}>
      <Logo />
      <div className={style.container}>        
        <div className={textError ? style.error : style.success}>
          {textError || textSuccess}
        </div>

        <div className={style.inputs}>
          <Input label='Логин'
            value={username}
            onInput={(e) => setUsername(e.target.value)}
            onKeyDown={auth}
          />
          <Input
            value={password}
            onInput={(e) => setPassword(e.target.value)}
            onKeyDown={auth}
            label='Пароль'          
            password
          />
        </div>

        <div className={style.buttons}>
          <Button
            label='Войти'
            onClick={auth}
            disabled={!username || !password || loading}
            loading={loading}
          />      
        </div>    
      </div>  
    </div>
  );
}

export default App;
